import { render, staticRenderFns } from "./FieldsCard.vue?vue&type=template&id=01bda4c6"
import script from "./FieldsCard.vue?vue&type=script&lang=ts"
export * from "./FieldsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports